import ISmartExchangeClaims from '@/models/se/ISmartExchangeClaims';
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

// Internal only: The set of mutation method names as strings.
// Only those mutations called by actions within this store module are necessary.
// Actions call mutations via this.context.commit() with the first argument as the mutation method name.
// const Mutate = {
//     setClaims: 'setClaims',
//     resetClaims: 'resetClaims'
// };

@Module({ namespaced: true, name: 'smartExchange' })
export default class SmartExchangeStoreModule extends VuexModule {
    // Private are the store properties
    private claims: ISmartExchangeClaims = {};

    /**
     * Get the smart exchange claims object
     */
    get SmartExchangeClaims(): ISmartExchangeClaims {
        return this.claims;
    }

    /**
     * Mutation: Set the store's smart exchange claims object with the given smartExchangeClaims
     * @param smartExchangeClaims
     */
    @Mutation
    setClaims(smartExchangeClaims: ISmartExchangeClaims) {
        this.claims = smartExchangeClaims;
    }

    /**
     * Mutation: Reset the store's smart exchange claims object to empty
     * @param smartExchangeClaims
     */
    @Mutation
    resetClaims() {
        this.claims = {};
    }

    /**
     * Mutation: Reset all state.
     */
    @Mutation
    resetState() {
        this.claims = {};
    }
}
